<template>
  <div class="ask-channel">
    <div class="top" v-if="channel">
      <van-row class="channel">
        <van-col span="6">
          <img :src="channel.img_url" :alt="channel.name" />
        </van-col>
        <van-col span="18" class="intro">
          <h2>{{ channel.alias }}</h2>
          <p class="ellipsis-2">{{ channel.share.description }}</p>
        </van-col>
      </van-row>
      <van-tabs v-if="channel.columns" color="#F6AB00" title-active-color="#F6AB00" v-model="params.column_id" @click="getCid">
        <van-tab title="最新" name=""></van-tab>
        <van-tab v-for="c in channel.columns" :key="'channel_' + c.id" :title="c.alias" :name="c.id"></van-tab>
      </van-tabs>
    </div>
    <div class="cenus">
      {{ total }}讨论
    </div>
    <div class="content">
      <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      >
      <div slot="loading" class="list-loading">
        <img :src="this.img.loading" />
        <span>正在刷新</span>
      </div>
      <div class="list-box" v-for="(item, index) in list" :key="'list_' + item.id">
        <div v-if="item.answer">
          <van-row type="flex" justify="space-between" v-if="item.answer.user">
            <van-col span="4">
              <img class="listhand" :src="item.answer.user.headimg_url ? item.answer.user.headimg_url : img.avatar">
            </van-col>
            <van-col span="16">
              <div class="membername">
                {{item.answer.user.user_name}}
              </div>
              <div class="sourtime">
                {{item.answer.answer_time}}
              </div>
            </van-col>
            <van-col class="bintright" span="4">
              <!-- <van-button plain round>+关注</van-button> -->
            </van-col>
          </van-row>
          <div class="listitle ellipsis-2">
            <router-link :to="{name: 'AskShowAnswer', params: {id: item.answer.id}}" class="c-black">{{ item.question }}</router-link>
          </div>
          <van-row gutter="10" v-if="item.answer.content.img">
            <van-col span="8">
              <router-link :to="{name: 'AskShowAnswer', params: {id: item.answer.id}}" class="c-black">
                <img class="picone" v-lazy="item.answer.content.img">
              </router-link>
            </van-col>
            <van-col span="16" class="f-14 ellipsis-4">
              <router-link :to="{name: 'AskShowAnswer', params: {id: item.answer.id}}" class="c-black">
                <img class="quespic" :src="img.answer">
                {{ item.answer.content.text }}
              </router-link>
            </van-col>
          </van-row>
          <div class="f-14 ellipsis-4" v-else>
            <router-link :to="{name: 'AskShowAnswer', params: {id: item.answer.id}}" class="c-black">
              <img class="quespic" :src="img.answer">
              {{ item.answer.content.text }}
            </router-link>
          </div>
          <div class="text-r">
            <router-link :to="{name: 'AskShowAnswer', params: {id: item.answer.id}}" class="c-blue f-14">查看答案</router-link>
          </div>
          <van-row type="flex" justify="space-between">
            <van-col span="14">
              <van-tag v-for="l in item.labels" :key="'ask_' + item.id + 'label_' + l.id" color="#F6AB00" round>{{ l.name }}</van-tag>
            </van-col>
            <van-col class="bintright" span="10">
              <span class="">
                <img class="binpic" :src="img.comment">
                <span class="sourtime">{{item.answer.reply_num}}</span>
              </span>
              <span class="binbox">
                <img class="binpic" @click="setPraise(index)" :src="item.answer.is_praise ? img.parise_have : img.parise">
                <span class="sourtime">{{item.answer.praise_num}}</span>
              </span>
            </van-col>
          </van-row>
        </div>
        <div v-else>
          <div class="listitle listitle2 ellipsis-2">
            <router-link :to="{name: 'AskShow', params: {id: item.id}}" class="c-black">
              <img class="quespic" :src="img.question">
              {{ item.question }}
            </router-link>
          </div>
          <div class="f-14">
            <router-link :to="{name: 'AskShow', params: {id: item.id}}" class="c-black">
              {{ item.content }}
            </router-link>
          </div>
          <div class="pic-box" v-if="item.image">
            <router-link :to="{name: 'AskShow', params: {id: item.id}}" class="c-black">
              <img class="pic_thumb" v-lazy="item.image[0]">
            </router-link>
          </div>
          <van-row type="flex" justify="space-between">
            <van-col span="14">
              <span class="sourtime">
                <span v-if="item.answer_num > 0">{{ item.answer_num + '个回答' }} </span>
                <span v-if="item.collect_num > 0">{{ item.collect_num + '个收藏' }}</span>
              </span>
            </van-col>
            <van-col class="bintright" span="10">
              <span class="sourtime">
                <router-link :to="''" class="c-blue f-14">我要回答</router-link>
              </span>
            </van-col>
          </van-row>
        </div>
      </div>
    </van-list>
  </div>
</div> 
</template>
<script>
  import ask from '../../../api/ask';
  import { mapState } from 'vuex';
  import {List, Row, Col, Tab, Tabs, Tag, Button} from "vant";

  export default {
    data () {
      return {
        params: {
          page: 1,
          size: 4,
          channel_id: 0,
          column_id: 0,
          filter: 0,
          user_id: 0
        },
        total: 0,
        channel: [],
        list: [],
        loading: false,
        finished: false,
        img: {
          avatar: require('../../../assets/img/default.jpg'),
          parise: require('../../../assets/img/parise.png'),
          parise_have: require('../../../assets/img/parise_have.png'),
          comment: require('../../../assets/img/comment.png'),
          loading: require('../../../assets/img/loading.gif'),
          question: require('../../../assets/img/question.png'),
          answer: require('../../../assets/img/answers.png')
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      this.getChannel()
      var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
    },
    activated () {
      if(this.source == 3||this.source == 7) {
        this.$appService.isShowReturn({state: true})
      }

      this.$store.commit('param/show', false)
    },
    methods: {
      setPraise (index) {
        if(this.source == 1){
          if(localStorage.getItem('token')){
            this.token=true
          }else{
            this.getAuthorization.getAuthorization();
          }
        }else{
          this.$appService.getToken(v => {
            if(v.token) {
              this.$store.dispatch('param/setToken', v.token)
            } else {
             var params={
                url:'',
                pagetype:0
              }
              this.$appService.needLogin(params)
            }
          })
        }

        if(this.user) {
          let type = this.list[index].answer.is_praise ? 2 : 1;
          ask.setPraise({id: this.list[index].answer.id, type: type}).then(res => {
            if(res.data.state == 1) {
              if(type == 1) {
                this.list[index].answer.is_praise = 1
                this.list[index].answer.praise_num += 1
                this.$toast.success('点赞成功')
              } else {
                this.list[index].answer.is_praise = 0
                this.list[index].answer.praise_num -= 1
                this.$toast.success('取消成功')
              }
            }
          })
        } else {
          this.$toast('请先登录')
          return false
        }

      },
      getCid() {
        this.params.page = 1;
        this.list = [];
        this.onLoad();
      },
      getChannel() {
        let id = this.$route.params.id
        if(this.$util.isEmpty(id)) {
          this.$toast('数据不存在')
          return false
        }
        this.params.channel_id = id
        ask.getChannelInfo(id).then(res => {
          if(res.data.state == 1) {
            this.channel = res.data.data
            this.$util.title(res.data.data.alias)
          }
        })
      },
      onLoad() {
        this.params.user_id = this.user ? this.user.id : 0
        // 异步更新数据
        setTimeout(() => {
          ask.getList(this.params).then(res => {
            this.list.push.apply(this.list, res.data.data.data)
            this.params.page += 1
            this.total = res.data.data.total
            this.loading = false

            if(res.data.data.data.length == 0) {
              this.finished = true
            }
          })
        }, 500);
      }
    },
    components: {
      [Row.name]: Row,
      [Col.name]: Col,
      [List.name]: List,
      [Tab.name]: Tab,
      [Tabs.name]: Tabs,
      [Tag.name]: Tag,
      [Button.name]: Button
    }
  };
</script> 

<style lang="scss">
.ask-channel {
  background-color: #F0F0F0;

  .top {
    padding-top: 10px;
    background-color: #FFF;

    .channel {
      padding: 10px;
    }
    img {
      width: 72px;
      height: 72px;
      display: block;
      object-fit: cover;
    }
    .intro {
      font-size: 12px;

      h2 {
        font-size: 15px;
        margin: 0;
      }
      p {
        color: #9A9A9A;
        line-height: 24px;
        margin: 5px 0;
      }
      span {
        color: #9A9A9A;
      }
    }
    .bintright{
      text-align:right;

      .van-button--default {
        color: #F6AB00;
        border: 1px solid #F6AB00;
        width: 60px;
        height: 25px;
        line-height: 25px;
        font-size: 12px;
        padding: 0;
      }
    }
    .van-tab span {
      font-size: 13px;
    }
  }
  .cenus {
    padding: 0 10px;
    background-color: #F0F0F0;
    color: #9A9A9A;
    font-size: 12px;
    line-height: 40px;
  }
  .content {
    background-color: #FFF;

    .list-box {
      padding: 15px 10px;
      border-bottom: 1px solid #EAEAEA;

      .quespic{
        width: 22px;
        height: 22px;
        vertical-align: middle;
      }
      .picone{
        width:100%;
        height:105px;
        border-radius:5px;
        object-fit: cover;
      }
      .listitle{
        font-size: 16px;
        font-weight:bold;
        line-height: 32px;
        letter-spacing: 1.4px;
        margin: 10px 0;

        &.listitle2 {
          margin-top: 0;
        }
      }
      .sourtime{
        font-size: 12px;
        color: #9A9A9A;

        .c-blue {
          font-size: 12px;
          color: #FFF;
          background: #33A1FF url(../../../assets/img/answer-button.png) no-repeat 8px center;
          background-size: 13px auto;
          width: 80px;
          height: 25px;
          line-height: 25px;
          display: inline-block;
          text-align: left;
          padding-left: 25px;
          border-radius: 12px;
          box-sizing: border-box;
        }
      }
      .bintright{
        text-align:right;
        .binbox{
          margin-left:20px;
        }
        .binpic{
          width:15px;
          height:14px;
          margin-right:8px;
          vertical-align: middle;
        }
        .van-button--default {
          color: #F6AB00;
          border: 1px solid #F6AB00;
          width: 60px;
          height: 25px;
          line-height: 25px;
          font-size: 12px;
          padding: 0;
        }
      }
      .pic-box {

        .pic_thumb {
          border-radius: 5px;
          width: 100%;
          height: 225px;
          object-fit: cover;
          display: block;
        }
      }
      .listhand{
        width:45px;
        height:45px;
        border-radius:30px;
      }
      .membername{
        font-size: 15px;
        font-weight: bold;
      }
      .van-tag{
        padding: 0 5px;
        margin-right: 5px;
      }
      .van-grid-item__content{
        padding: 2.5px;
      }

    }
  }
}
</style>
